export function slugify(companyName) {
  // Normalize the string to decompose Unicode characters (like accents)
  const normalized = companyName.normalize("NFD");
  // Remove diacritical marks
  const withoutDiacritics = normalized.replace(/[\u0300-\u036f]/g, "");
  // Convert the string to lowercase
  const lowerCased = withoutDiacritics.toLowerCase();
  // Remove characters that are not alphanumeric, spaces, or hyphens
  const cleaned = lowerCased.replace(/[^a-z0-9\s-]/g, "");
  // Replace spaces and multiple hyphens with a single hyphen, and trim extra hyphens
  const slug = cleaned.trim().replace(/[\s-]+/g, "-");
  return slug;
}

/**
 * Parses a full name into first name and last name.
 * First name includes all parts except the last word.
 * @param {string} fullName - The full name to parse
 * @returns {Object} Object containing firstName and lastName
 */
export function parseFullName(fullName = '') {
  const nameParts = fullName.trim().split(/\s+/).filter(Boolean);

  if (nameParts.length === 0) {
    return { firstName: '', lastName: '' };
  }

  if (nameParts.length === 1) {
    return { firstName: nameParts[0], lastName: '' };
  }

  const lastName = nameParts[nameParts.length - 1];
  const firstName = nameParts.slice(0, -1).join(' ');

  return { firstName, lastName };
}

/**
 * Returns the plural form of a word if count is not 1, otherwise returns singular.
 * @param {string} word - The singular form of the word
 * @param {number} count - The count to determine pluralization
 * @returns {string} The pluralized word if count !== 1, otherwise the singular form
 */
export function pluralize(word, count) {
  return count === 1 ? word : `${word}s`;
}
